import Template from "@/src/components/templates/SubjectDIDs/SubjectDIDsOverviewTemplate";

const SubjectDIDsOverview = () => <Template />;

export default SubjectDIDsOverview;
